"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ComponentRoot = _styledComponents.default.ul.withConfig({
  displayName: "EdgeLegend__ComponentRoot",
  componentId: "sc-1d63mja-0"
})(["padding:0;margin:0;list-style-type:none;"]);

var LegendItem = _styledComponents.default.li.withConfig({
  displayName: "EdgeLegend__LegendItem",
  componentId: "sc-1d63mja-1"
})(["position:relative;display:flex;flex-direction:row;align-items:center;padding-left:20px;& > *{margin-right:4px;}"]);

var LegendItemLine = (0, _styledComponents.default)(LegendItem).withConfig({
  displayName: "EdgeLegend__LegendItemLine",
  componentId: "sc-1d63mja-2"
})(["&::before{content:\"\";width:12px;height:4px;border-radius:2px;background-color:", ";position:absolute;top:10px;left:0;}"], function (_ref) {
  var fill = _ref.fill;
  return fill;
});
/*
TODO: Combine node and edge legends?
const LegendItemCircle = styled(LegendItem)`
  &::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ fill }) => fill};
    position: absolute;
    top: 9px;
    left: 0;
  }
`
*/

var EdgeLegend = function EdgeLegend(props) {
  var edge = props.edge,
      colors = props.colors,
      themes = props.themes,
      inverted = props.inverted;
  var items = edge.themes.sort(function (a, b) {
    return b.count - a.count;
  }).map(function (edgeTheme) {
    var theme = themes.find(function (t) {
      return t.themeId === edgeTheme.themeId;
    });
    return _objectSpread(_objectSpread({}, edgeTheme), {}, {
      color: colors(edgeTheme.themeId),
      name: theme ? theme.name : ''
    });
  });
  return /*#__PURE__*/_react.default.createElement(ComponentRoot, null, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(LegendItemLine, {
      key: item.themeId,
      fill: item.color
    }, /*#__PURE__*/_react.default.createElement("span", null, item.name, " (", item.count, ")"));
  }));
};

EdgeLegend.propTypes = {
  edge: _propTypes.default.shape({
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    themes: _propTypes.default.arrayOf(_propTypes.default.shape({
      themeId: _propTypes.default.string.isRequired,
      count: _propTypes.default.number.isRequired
    }))
  }).isRequired,
  themes: _propTypes.default.arrayOf(_propTypes.default.shape({
    themeId: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired
  })),
  inverted: _propTypes.default.bool
};
EdgeLegend.defaultProps = {
  inverted: false
};

var _default = (0, _styledComponents.withTheme)(EdgeLegend);

exports.default = _default;
//# sourceMappingURL=EdgeLegend.js.map